import { render, staticRenderFns } from "./TitleDetailQuickActionBarV1.vue?vue&type=template&id=b3676a20&scoped=true"
import script from "./TitleDetailQuickActionBarV1.vue?vue&type=script&setup=true&lang=ts"
export * from "./TitleDetailQuickActionBarV1.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./TitleDetailQuickActionBarV1.vue?vue&type=style&index=0&id=b3676a20&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3676a20",
  null
  
)

export default component.exports